import { ApolloProvider } from '@apollo/client';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { getClient } from './utils/apollo-client';

import './index.css';
import PageContainer from './components/pages/PageContainer';
import { initializeTitleState } from './components/pages/title-state';

interface PageModuleOptions {
    branch: string;
    siteTitle: string;
}

interface ModuleParams {
    options: PageModuleOptions;
}

function pageModule({ options: { branch, siteTitle } }: ModuleParams): void {
    initializeTitleState({ branch, siteTitle });

    const element = document.getElementById('js-page')!;
    const root = createRoot(element);
    root.render(
        <StrictMode>
            <ApolloProvider client={getClient()}>
                <PageContainer />
            </ApolloProvider>
        </StrictMode>
    );
}

export default pageModule;
